import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddrawmaterialComponent } from '../../rawmaterial/addrawmaterial/addrawmaterial.component';

@Component({
  selector: 'app-addrecipedetail',
  templateUrl: './addrecipedetail.component.html',
  styleUrls: ['./addrecipedetail.component.css']
})
export class AddrecipedetailComponent implements OnInit {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";


  purchaseBO: any = {}


  ismanualclose: boolean;

  isaccountaddmode: boolean = false;

  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  recipeform = new FormGroup({
    recipedetailsid: new FormControl(0),
    recipeid: new FormControl(0),
    rawmaterialid: new FormControl(null, Validators.required),
    rawmaterialname: new FormControl(null),
    qty: new FormControl(null, Validators.required),
    unitprice: new FormControl(null, Validators.required),
    subtotal: new FormControl(null),
    uomid: new FormControl(null, Validators.required),
    taxid: new FormControl(null, Validators.required),
    taxname: new FormControl(null),
    taxrate: new FormControl(null),
    taxamt: new FormControl(null),
    cgsttaxrate: new FormControl(null),
    cgsttaxamt: new FormControl(null),
    sgsttaxrate: new FormControl(null),
    sgsttaxamt: new FormControl(null),
    igsttaxrate: new FormControl(null),
    igsttaxamt: new FormControl(null),
    taxable: new FormControl(null),
    nettotal: new FormControl(null),
    inactive: new FormControl(null),
  });


  formname: String = "Recipe";



  @Input() recipedetailsid: number = 0
  @Input() recipeid: number = 0

  @Input() recipedetailsBO: any = {};

  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {

  }

  ngOnInit() {
    try {
      this.fnOnInitForm();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.recipeform.reset();
      this.fnInitializeForm();

      this.fnGetRawmaterial();
      this.fnGetTax();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }



  fnInitializeForm() {
    this.recipeform.setValue({
      recipedetailsid: this.recipedetailsBO.recipedetailsid,
      recipeid: this.recipedetailsBO.recipeid,
      rawmaterialid: this.recipedetailsBO.rawmaterialid,
      rawmaterialname: this.recipedetailsBO.rawmaterialname,
      qty: this.recipedetailsBO.qty,
      unitprice: this.recipedetailsBO.unitprice,
      subtotal: this.recipedetailsBO.subtotal,
      uomid: this.recipedetailsBO.uomid,
      taxid: this.recipedetailsBO.taxid,
      taxname: this.recipedetailsBO.taxname,
      taxrate: this.recipedetailsBO.taxrate,
      taxamt: this.recipedetailsBO.taxamt,
      cgsttaxrate: this.recipedetailsBO.cgsttaxrate,
      cgsttaxamt: this.recipedetailsBO.cgsttaxamt,
      sgsttaxrate: this.recipedetailsBO.sgsttaxrate,
      sgsttaxamt: this.recipedetailsBO.sgsttaxamt,
      igsttaxrate: this.recipedetailsBO.igsttaxrate,
      igsttaxamt: this.recipedetailsBO.igsttaxamt,
      taxable: this.recipedetailsBO.taxable,
      nettotal: this.recipedetailsBO.nettotal,
      inactive: false,
    })
  }




  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;
    var qty = this.recipeform.get('qty').value;
    if (this.loginService.fnCheckZeroDetcimal(qty) === 0) {
      this.errtxt = "Quantity is cannot be empty"
      this.recipeform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }


    // for (let row of this.purchasedetailscoll) {
    //   if (row.rawmaterialid > 0) {
    //     _detailscheck = true;
    //   }
    // }

    // if (!_detailscheck) {
    //   this.errtxt = "Purchase Details cannot be empty"
    //   this.recipeform.controls['inactive'].setErrors({ 'notfound': true });
    //   _ischeck = true;
    // }
    // if (!_ischeck) {
    //   for (let row of this.purchasedetailscoll) {

    //     if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
    //       this.errtxt = "Quantity is cannot be empty"
    //       this.recipeform.controls['inactive'].setErrors({ 'notfound': true });
    //       _ischeck = true;
    //     }

    //   }
    // }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.recipeform.get('inactive')) {
      this.recipeform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.recipeform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          recipedetailsid: this.recipeform.get('recipedetailsid').value,
          recipeid: this.recipeform.get('recipeid').value,
          rawmaterialid: this.recipeform.get('rawmaterialid').value,
          rawmaterialname: this.recipeform.get('rawmaterialname').value,
          qty: this.recipeform.get('qty').value,
          unitprice: this.recipeform.get('unitprice').value,
          subtotal: this.recipeform.get('subtotal').value,
          uomid: this.recipeform.get('uomid').value,
          taxid: this.recipeform.get('taxid').value,
          taxname: this.recipeform.get('taxname').value,
          taxrate: this.recipeform.get('taxrate').value,
          taxamt: this.recipeform.get('taxamt').value,
          cgsttaxrate: this.recipeform.get('cgsttaxrate').value,
          cgsttaxamt: this.recipeform.get('cgsttaxamt').value,
          sgsttaxrate: this.recipeform.get('sgsttaxrate').value,
          sgsttaxamt: this.recipeform.get('sgsttaxamt').value,
          igsttaxrate: this.recipeform.get('igsttaxrate').value,
          igsttaxamt: this.recipeform.get('igsttaxamt').value,
          taxable: this.recipeform.get('taxable').value,
          nettotal: this.recipeform.get('nettotal').value,
        }

        var result = {
          'checkstatus': 'DONE',
          'data': data
        }

        this.emitData.emit(result);
        this.activeModal.close(true);



      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }




  //Close
  async fnCloseForm() {

    try {


      var result = {
        'checkstatus': 'CANCEL',
        'data': null
      }

      this.emitData.emit(result);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial() {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial()
        }, (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetTax() {
    this.isLoadingResult = true;

    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    var row = {
      recipedetailsid: this.recipeform.get('recipedetailsid').value,
      recipeid: this.recipeform.get('recipeid').value,
      rawmaterialid: this.recipeform.get('rawmaterialid').value,
      rawmaterialname: this.recipeform.get('rawmaterialname').value,
      qty: this.recipeform.get('qty').value,
      unitprice: this.recipeform.get('unitprice').value,
      subtotal: this.recipeform.get('subtotal').value,
      uomid: this.recipeform.get('uomid').value,
      taxid: this.recipeform.get('taxid').value,
      taxname: this.recipeform.get('taxname').value,
      taxrate: this.recipeform.get('taxrate').value,
      taxamt: this.recipeform.get('taxamt').value,
      cgsttaxrate: this.recipeform.get('cgsttaxrate').value,
      cgsttaxamt: this.recipeform.get('cgsttaxamt').value,
      sgsttaxrate: this.recipeform.get('sgsttaxrate').value,
      sgsttaxamt: this.recipeform.get('sgsttaxamt').value,
      igsttaxrate: this.recipeform.get('igsttaxrate').value,
      igsttaxamt: this.recipeform.get('igsttaxamt').value,
      taxable: this.recipeform.get('taxable').value,
      nettotal: this.recipeform.get('nettotal').value,
    }

    this.recipedetailsBO.subtotal = row.qty * row.unitprice;

    this.recipeform.patchValue({ 'subtotal': this.recipedetailsBO.subtotal });
    //this.subtotal = this.subtotal + Number(row.subtotal)


    this.recipedetailsBO.taxamt = Number(this.fnConvertDecimal(this.recipedetailsBO.subtotal)) * Number(this.fnConvertDecimal(row.taxrate)) / 100
    this.recipeform.patchValue({ 'taxamt': this.recipedetailsBO.taxamt });

    //GST      
    this.recipedetailsBO.cgsttaxamt = Number(this.fnConvertDecimal(this.recipedetailsBO.taxamt)) / 2
    this.recipedetailsBO.sgsttaxamt = Number(this.fnConvertDecimal(this.recipedetailsBO.taxamt)) / 2
    this.recipedetailsBO.igsttaxamt = 0

    this.recipeform.patchValue({
      'cgsttaxamt': this.recipedetailsBO.cgsttaxamt,
      'sgsttaxamt': this.recipedetailsBO.sgsttaxamt,
      'igsttaxamt': this.recipedetailsBO.igsttaxamt
    })

    this.recipedetailsBO.taxable = Number(this.fnConvertDecimal(this.recipedetailsBO.subtotal));
    this.recipeform.patchValue({ 'taxable': this.recipedetailsBO.taxable });

    this.recipedetailsBO.nettotal = Number(this.fnConvertDecimal(this.recipedetailsBO.taxable)) + Number(this.fnConvertDecimal(this.recipedetailsBO.taxamt))
    this.recipeform.patchValue({ 'nettotal': this.recipedetailsBO.nettotal });
  }




  fnChangeRawmaterial() {

    var row = {
      rawmaterialid: this.recipeform.get('rawmaterialid').value,
    }

    var _prodname = "", _uomid = null, _unitprice = 0, _taxid = null;

    for (let abo of this.rawmaterialColl) {
      if (row.rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.purchaseprice;
        _uomid = abo.purchaseuomid;
        _taxid = abo.taxid;
      }
    }
    this.recipedetailsBO.rawmaterialname = _prodname;
    this.recipedetailsBO.unitprice = _unitprice;
    this.recipedetailsBO.uomid = _uomid;
    this.recipedetailsBO.taxid = _taxid;

    this.recipeform.patchValue({ 'rawmaterialname': this.recipedetailsBO.rawmaterialname });
    this.recipeform.patchValue({ 'unitprice': this.recipedetailsBO.unitprice });
    this.recipeform.patchValue({ 'uomid': this.recipedetailsBO.uomid });
    this.recipeform.patchValue({ 'taxid': this.recipedetailsBO.taxid });

    this.fnChangeTax()
  }


  fnChangeTax() {


    var row = {
      taxid: this.recipeform.get('taxid').value,
    }



    var _taxname = "", _taxrate = 0;

    var _cgsttaxrate = 0, _sgsttaxrate = 0, _igsttaxrate = 0;

    for (let abo of this.taxColl) {
      if (row.taxid === abo.taxid) {
        _taxname = abo.taxname;
        _taxrate = abo.taxrate;
        _cgsttaxrate = abo.cgsttaxrate;
        _sgsttaxrate = abo.sgsttaxrate;
        _igsttaxrate = abo.igsttaxrate;
      }
    }
    this.recipedetailsBO.taxname = _taxname;
    this.recipedetailsBO.taxrate = _taxrate;
    this.recipedetailsBO.cgsttaxrate = _cgsttaxrate;
    this.recipedetailsBO.sgsttaxrate = _sgsttaxrate;
    this.recipedetailsBO.igsttaxrate = _igsttaxrate;

    this.recipeform.patchValue({ 'taxname': this.recipedetailsBO.taxname });
    this.recipeform.patchValue({ 'taxrate': this.recipedetailsBO.taxrate });
    this.recipeform.patchValue({ 'cgsttaxrate': this.recipedetailsBO.cgsttaxrate });
    this.recipeform.patchValue({ 'sgsttaxrate': this.recipedetailsBO.sgsttaxrate });
    this.recipeform.patchValue({ 'igsttaxrate': this.recipedetailsBO.igsttaxrate });


    this.fnCalcDetails()

  }



  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.recipedetailsBO.rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial();

    });
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
